module.exports = __webpack_public_path__ + "img/left_btn.63aa5ab8.svg";